import { Flex, Text } from "@chakra-ui/react";
import { OptionProps, Select, GroupBase, Props } from "chakra-react-select";
import {
    PropertyLienTypeModel,
    usePropertyLienTypes,
} from "hooks/usePropertyLienType";

const CustomOption = ({
    data,
    innerProps,
}: OptionProps<PropertyLienTypeModel>) => (
    <Flex
        {...innerProps}
        p={2}
        gap={4}
        borderRadius="md"
        _hover={{ bg: "gray.50" }}
        cursor="pointer"
        alignItems="center"
    >
        <Flex direction="column" alignItems="start">
            <Text color="gray.600">{data.name}</Text>
            <Text fontSize="sm" color="gray.500">
                {data.description}
            </Text>
        </Flex>
    </Flex>
);

interface PropertyLienTypeSelectProps
    extends Props<
        PropertyLienTypeModel,
        false,
        GroupBase<PropertyLienTypeModel>
    > {
    propertyLienType: PropertyLienTypeModel | null;
    setPropertyLienType: (
        propertyLienType: PropertyLienTypeModel | null
    ) => void;
}

export const PropertyLienTypeSelect = ({
    propertyLienType,
    setPropertyLienType,
    ...props
}: PropertyLienTypeSelectProps) => {
    const { data: propertyLienTypes, isLoading } = usePropertyLienTypes();

    return (
        <Select<PropertyLienTypeModel>
            options={
                propertyLienTypes?.sort((a, b) =>
                    a.name.localeCompare(b.name)
                ) ?? []
            }
            getOptionLabel={(b) => b.name}
            getOptionValue={(b) => b.id.toString()}
            components={{ Option: CustomOption }}
            isLoading={isLoading}
            chakraStyles={{
                placeholder: (provided) => ({
                    ...provided,
                    textAlign: "left",
                }),
                singleValue: (provided) => ({
                    ...provided,
                    textAlign: "left",
                }),
            }}
            placeholder="Select a property lien type..."
            noOptionsMessage={() => "No property lien types found."}
            onChange={(newValue) => setPropertyLienType(newValue)}
            value={propertyLienType}
            variant="primary"
            filterOption={(option, inputValue) =>
                [option.data.name, option.data.description].some((field) =>
                    field?.toLowerCase().includes(inputValue.toLowerCase())
                )
            }
            isClearable={true}
            {...props}
        />
    );
};
